<template>
<div class="container-body login-body-color">
  <div class="container" >
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div
          class="card o-hidden border-0 shadow-lg my-5 login-border-radius" 
        >
          <div class="card-body p-0">
            <div class="row">
              <div class="col-lg-6">
                <img src="./loginPageBanner.png" class="login-logo" alt="logo" />
              </div>
              <div class="col-lg-6">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4"><strong>{{ $t("LOGIN") }}</strong></h1>
                  </div>
                  <br />
                   <br />
                    <br />
                 
                  <form class="user" @submit.prevent="login">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control form-control-user"
                        v-model.trim="$v.userDetails.userid.$model"
                        id="exampleInputEmail"
                        aria-describedby="emailHelp"
                        placeholder="ログインID"
                        autocomplete="off"
                      />
                     
                    </div>
                    <div class="form-group">
                      <input
                        type="password"
                        v-model.trim="$v.userDetails.password.$model"
                        class="form-control form-control-user"
                        id="exampleInputPassword"
                        :placeholder="$t('PASSWORD')"
                        autocomplete="off"
                      />
                     <br />
                    </div>
                    <div class="form-group">
                      <div class="custom-control custom-checkbox small">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          v-model.trim="$v.userDetails.remember.$model"
                          id="customCheck"
                        />
                        <label class="custom-control-label" for="customCheck">{{
                          $t("REMEMBERME")
                        }}</label>
                      </div>
                    </div>

                    <button
                      class="btn btn-primary btn-user btn-block"
                      type="submit"
                    >
                      {{ $t("LOGIN") }}
                      <span
                        v-if="submitted"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span class="sr-only">Loading...</span>
                    </button>
                    <div class="form-group text-center">
                      
                    </div>
                  </form>
                  <div class="text-center">
                    <a class="small" href="#/ForgotPassword"
                      >{{ $t("ForgotYourPassword") }}</a
                    >
                  </div>

                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { LOGIN } from "@/store/actions.type";
import { mapGetters } from "vuex";
import _ from "lodash";
import store from "./../../../store/index.js";
import { filters } from "./../../../filters/common";

export default {
  name: "Login",
  components: {  },
  data() {
    return {
      MIG: filters.menuList,
      authStore: store.state.auth,
      userDetails: {
        userid: "",
        password: "",
        remember: ""
      },
      submitted: false
    };
  },
  validations: {
    userDetails: {
      userid: { required },
      password: { required },
      remember: {}
    }
  },
  methods: {
    login(){
      if (this.userDetails.remember === true) {
        $cookies.config("7d");
        $cookies.set("userid", this.userDetails.userid);
        $cookies.set("password", this.userDetails.password);
      } else {
        $cookies.remove("userid");
        $cookies.remove("password");
      }
      this.submitted = true;
      this.$v.$touch();
      if (!this.$v.userDetails.$invalid) {
        localStorage.userid = this.userDetails.userid;
        this.$store.dispatch(LOGIN, this.userDetails).then(data => {
          this.submitted = false;
          let permissions = _.filter(
            this.authStore.permissions,
            item => item.hide == 0
          );
          if (_.get(data, "status", 0)) {
            if (_.get(data, "success.isfirstime", false)) {
              this.$router.push("/setPassword");
              return;
            }
            if (permissions.length) {
              /* Find dashboard menu */
              let findDashboard = _.find(
                permissions,
                item =>
                  item.module == "MIG_DASHBOARD" ||
                  item.module == "PARTNER_DASHBOARD"
              );
              let menuItem;
              if (findDashboard) {
                 menuItem = _.find(
                this.MIG,
                item => item.module == findDashboard.module
              );
                this.$router.push(menuItem.url);
                return;
              }
              let firstMenu = permissions[0];
              menuItem = _.find(
                this.MIG,
                item => item.module == firstMenu.module
              );
              if (menuItem) {
                if (menuItem.submenu.length) {
                  this.$router.push(menuItem.submenu[0].url);
                } else {
                  this.$router.push(menuItem.url);
                }
              } else {
                this.$router.push("/dashboard");
              }
            } else {
              this.$router.push("/dashboard");
            }
          } else {
            this.$toast.error({
              message: _.get(data, "message", "error")
            });
          }
        });
      } else {
       
        this.submitted = false;
      }
    }
  },
  mounted() {
    if ($cookies.get("userid")) {
      this.userDetails.remember = true;
      this.userDetails.userid = $cookies.get("userid");
      this.userDetails.password = $cookies.get("password");
    }
  },
  created() {
    this.$toast.removeAll();
  },
  computed: {
    ...mapGetters([""])
  }
};
</script>
<style>
.IconLogo {
  height: 18%;
  margin: 5%;
}
.container-body {
            position: absolute;
            width: 100%;
            min-height: 100%;
            left: 0;
            top: 0;
        }
</style>
